import api from './api';

export const newClientsAPI = {
  list: () => api.get('/api/onboarding-review/new-clients').then((r) => r.data),
};

export const STAGES = [
  ['needs_action', 'Needs action'],
  ['invited', 'Invited'],
  ['in_progress', 'In progress'],
  ['ready', 'Ready to review'],
  ['approved', 'Approved'],
  ['cancelled', 'Cancelled'],
  ['all', 'All'],
];
export const STAGE_LABEL = Object.fromEntries(STAGES);
export const STAGE_COLOR = {
  invited: 'bg-blue-100 text-blue-800', in_progress: 'bg-amber-100 text-amber-800', ready: 'bg-rose-100 text-rose-800',
  approved: 'bg-green-100 text-green-800', cancelled: 'bg-muted text-muted-foreground',
};
export const ORIGIN_LABEL = { invited: 'Invited', self_registered: 'Self-registered', family: 'Family member' };
export const inviteLink = (token) => `${window.location.origin}/onboard/${token}`;
